import { useDailyEquipmentConstraintsQuery } from '~/hooks/tanstack-query/optimus/hospital-constraints/equipment/useDailyEquipmentConstraintsQuery'
import { useOtelTracker } from '~/hooks/useOtelTracker'

import { Section } from '../../Section'
import { Table } from './Table'

export const EquipmentConstraints = () => {
    const { isLoading, data: constraints } = useDailyEquipmentConstraintsQuery()

    useOtelTracker({ name: 'HospitalConfig.Constraints.Equipment.Table', isLoading })

    return (
        <Section title="Utstyrsbegrensninger" description="Viser begrensninger for utstyr per dag og hvilke operasjonstyper som deler utstyret.">
            <Table constraints={constraints ?? []} isLoading={isLoading} />
        </Section>
    )
}
